var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHourglass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.7,
    height: 24,
    viewBox: "0 0 16.7 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(539.35 -339.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hourglass",
    d: "M-523.87,347.04v-5.77h1.22v-1.72h-16.7v1.72h1.22v5.77l3.9,3.9v2.34l-4.33,4.31v4.23h-.79v1.73h16.7v-1.73h-.79v-4.23l-4.33-4.31v-2.34Zm-1.31,11.27V360l-.62-.43a9.191,9.191,0,0,0-10.4,0l-.62.43v-1.69l4.33-4.31v-3.79l-3.9-3.9v-5.04h10.77v5.04l-3.9,3.9V354Z",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHourglass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hourglass.76c632230fa656e00436392657c74086.svg";